<script lang="ts" setup>
import { type Ref, ref, watchEffect } from 'vue';

type Row = Record<string, unknown>;

const props = withDefaults(defineProps<{
    items?: Row[]
}>(), {
    items: () => [null] as unknown as Row[]
});

const items: Ref<Row[]> = ref(props.items);

watchEffect(() => {
    items.value = props.items;
});

function splice(start: number, deleteCount: number, ...args: Row[]) {
    items.value.splice(start, deleteCount, ...args);
}
</script>

<template>
    <template v-if="items.length">
        <tr
            v-for="(item, i) in items"
            :key="i">
            <slot
                v-bind="{
                    add: (...args: Row[]) => items.push(...args),
                    remove: () => items.splice(items.indexOf(item), 1),
                    item,
                    splice
                }"
                :index="i"
                :is-odd="i % 2 === 1"
                :is-even="i % 2 === 0"
                :is-first-row="i === 0"
                :is-last-row="i === items.length - 1" />
        </tr>
    </template>
</template>